const core = {
   baseUrl: process.env.REACT_APP_CORE_BASE_URL,
};
export default core;
